import CONSTANTS from "../constant/general";

export const getExclusionOptions = (exclusionMatrix: {
  [key: string]: string
}[], key: string, code: string, exclusionMatrixOption: { [key: string]: string[] }, options: {
  [key: string]: string
}) => {
  const ringExclusionMatrix: { [key: string]: string[] } = {};
  const selectedExclusionData = exclusionMatrix?.filter((item) => item[key]?.toString() === code?.toString());
  Object.keys(exclusionMatrixOption).forEach(option => {
    const otherExclusionOption = Object.keys(exclusionMatrixOption)?.filter(item => item !== key)?.filter(item => item !== option);
    const filteredData = selectedExclusionData?.filter(data => {
      return otherExclusionOption.every(k => {
        return data[k]?.toString() === { ...options, [key]: code }[k]?.toString();
      });
    });
    ringExclusionMatrix[option] = filteredData?.map(data => data[option]);
  });
  return ringExclusionMatrix
}
export const exclusionMatrixData = async (styleId: string, category = CONSTANTS.RING_CATEGORY_CODE) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_PDP_OPTIONS_KEY}?ring_builder=${styleId}&exclusion=true&category=${category}`);
    if (!response.ok) {
      console.log(new Error(`HTTP error! Status: ${response.status}`));
    }
    return await response.json();
  } catch (e) {
    console.log(e)
  }
}
